import { useEffect, useState } from 'react'
import Cache from '@fs/zion-cache'

import { CACHE } from '../../helpers'

const dupeCheckModalCache = new Cache({ storeName: CACHE.STORE_NAME })

export default function useCachedDupeCheckSeen() {
  const [seenDupeCheckModal, setSeenDupeCheckModal] = useState()

  useEffect(() => {
    dupeCheckModalCache.getItem(CACHE.ADD_PERSON_DUPE_CHECK_SEEN).then((hasSeenDupeCheckModalVal) => {
      setSeenDupeCheckModal(hasSeenDupeCheckModalVal === true)
    })
  }, [])

  function setCacheSeenDupeCheckModal() {
    dupeCheckModalCache.setItem(CACHE.ADD_PERSON_DUPE_CHECK_SEEN, true)
    setSeenDupeCheckModal(true)
  }

  return [seenDupeCheckModal, setCacheSeenDupeCheckModal]
}
